export default {
  header: 'Cette semaine',
  metrics: {
    points: 'Points',
    visits: 'Visites',
    in_store_sign_ups: 'Inscriptions en magasin',
    rewards_redeemed: 'Récompenses échangées',
  },
};
